<template>
    <div class="templete no_print">
            <section class="gradeSection">
                <div class="path">
                    <div class="clearfix">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addDialogVisible=!addDialogVisible">新增设置</el-button>
                        <el-button class="funcPublicBtn" @click="batchDel">删除设置</el-button>
                        <div class="contractLabel" style="position:relative;">
                            <span class="redQuestion"></span>
                            <div class="labelTip">
                                <div class="labelZhu">注:</div>
                                <div class="laCbelTipC">
                                    <div></div>
                                    <div>1.类型：整租库</div>
                                    输入的月租金额会每天平摊至该仓库的结余库存，即获得该仓库每件货物的每日变量仓储费用；
                                    <div class="tipbot">2.类型：监管库</div>
                                    输入的监管库单价（元/m³/天），系统将会每天结算该监管库结余库存的仓储费用;
                                    <div class="tipbot">3.仓储设置启用前，期初库存须手动生成期初仓储费;</div>
                                    <div class="tipbot">4.清空仓储费后，该仓库所有现货库存仓储费归0;</div>
                                    <div class="tipbot">5.启用状态时系统将在每天23：00开始结算生成仓储费及库存结余，请务必在此之前保证出入库数据准确并停止出入库操作;</div>
                                    <div class="tipbot">6.禁用状态时不再计算生成更新仓储费。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tableBox">
                    <el-table :data="list" ref="listDetailTable" style="width: 100%" height="100%" size="mini" @row-click="toggleSelection"  :row-class-name="tableRowClassName" @selection-change="selectionChange" border stripe highlight-current-row show-summary header-cell-class-name="list_table_th">
                            <el-table-column class-name="tableIndex"  type="selection" align="center" :selectable="checkSelectable" width="45"></el-table-column>
                            <el-table-column type="index" label="序号" width="50"></el-table-column>
                            <el-table-column prop="warehouse" label="仓库名称" width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="warehouse_type_text" label="仓库类型" width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="monthly_rent" label="仓库月租金额" width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="daily_rent" label="元/m³/天" width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="payee" label="服务商名称" width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="init_cube" label="期初日均库存m³" width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column label="期初仓储费" width="120" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div v-if="scope.row.init_status==0"  @click="toBeGenerated(scope.row.id,scope.row.status)" class="emptyStatus">
                                        {{scope.row.init_status_text}}
                                    </div>
                                    <div v-else>
                                        <span>{{scope.row.init_status_text}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="清空仓储费" width="120" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div @click="empty(scope.row.id,scope.row.status)" class="emptyStatus">
                                       清空
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column label="费用日期" width="120" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div>
                                        <span v-if="scope.row.fee_day>0">{{scope.row.fee_day}}天</span>
                                        <span v-else>-</span>
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column label="状态" width="100">
                                <template slot-scope="scope">
                                    <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,scope.row.status)">{{scope.row.status_text}}</div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="等级" prop="name" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div class="starTableList clearfix">
                                        <div class="star gradeStar" v-for="index of parseInt(scope.row.warehouse)" :key="index"></div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="等级说明" prop="description" show-overflow-tooltip></el-table-column>
                            <el-table-column label="状态" width="100">
                                <template slot-scope="scope">
                                    <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,scope.row.status)">{{scope.row.status_label}}</div>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    <!-- <tabletem :isSetCol="true" scene="fee.list" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem> -->
                </div>
            </section>
            <!--新增 START-->
            <el-dialog v-dialog-drag title="新增仓储费设置" :visible.sync="addDialogVisible" width="400px" class="eldialog eldialogLine" :model="false" custom-class="full_dialog">
                <el-form  :model="warehouseForm" :rules="addDialogRules" ref="warehouseForm"  class="clearfix dialogFormB">
                    <el-form-item  label="仓库名称：" prop="warehouse_id">
                        <el-select v-model="warehouseForm.warehouse_id" @visible-change="getSelectList('warehouse')" clearable>
                            <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="仓库类型：" prop="warehouse_type">
                        <el-select v-model="warehouseForm.warehouse_type" @visible-change="getSelectList('warehouseTypes')" clearable>
                            <el-option v-for="list in selectMap.warehouseTypes" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item  label="费用日期：" prop="fee_day">
                         <el-select v-model="warehouseForm.fee_day">
                            <el-option value="0" label="每月1号"></el-option>
                            <el-option value="1" label="每月15号"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-date-picker v-model="warehouseForm.fee_day" value-format="yyyy-MM-dd" type="date" placeholder="费用日期"></el-date-picker> -->
                    <el-form-item  label="期初日均库存：" prop="init_cube" v-if="warehouseForm.warehouse_type==1">
                         <el-input v-model="warehouseForm.init_cube">
                            <template slot="append">m³</template>
                         </el-input>
                    </el-form-item>
                    <el-form-item  label="服务商名称：" prop="payee">
                        <el-input v-model="warehouseForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="月租金额："  v-if="warehouseForm.warehouse_type==1" prop="monthly_rent">
                         <el-input v-model="warehouseForm.monthly_rent">
                         </el-input>
                    </el-form-item>
                    <el-form-item  label="单价金额：" v-if="warehouseForm.warehouse_type==2" prop="daily_rent">
                         <el-input v-model="warehouseForm.daily_rent">
                            <template slot="append">元/m³/天</template>
                         </el-input>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="warehouseForm.remark"></el-input>
                    </el-form-item>
                     <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="addDialogVisible=!addDialogVisible" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="add">确认</el-button>
                    </div>
                </el-form>
            </el-dialog>
            <!--新增 END-->
             <!--添加费用START-->
        <!-- <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="getSelectList('purchaseCost')" clearable>
                            <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.id" @click="saveOutFee">确认</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-else @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog> -->
        <!--添加费用END-->
         </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;font-weight: 600;top:20px;left:-150px;z-index:1;width:300px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;z-index: 100;}
    .laCbelTipC{color:#606266;font-size: 14px;font-weight: 600;}
    .labelZhu{font-size: 14px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex;  }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex;  justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    // .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    .gradeSection{width:1280px;flex: 1;display: flex;flex-direction: column;}

    // .starList{margin-bottom:10px;}
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
    .eldialogLine .dialogFormB .el-form-item {
        margin-bottom: 15px;
    }
    .tipbot{padding-top: 10px;}
</style>
<script>
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            tabletem
        },
        data(){
            return{
                params:{
                    keyword: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                radio : "",
                radioGrade:"",
                orderTime:"",
                type:2,//2.新增 3.修改
                addDialogVisible:false,
                starNumber:0,
                warehouseForm:{
                    warehouse_id:"",
                    warehouse_type:"",
                    monthly_rent:'',
                    daily_rent:'',
                    payee:'',
                    // fee_day:'',
                    remark:'',
                },
                tableCol:[
                    {colName:"仓库名称",colKey:"warehouse",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库类型",colKey:"warehouse_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"仓库月租金额",colKey:"monthly_rent",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"元/m³/天",colKey:"daily_rent",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"启用状态",colKey:"status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                selectMap:{
                    warehouse:[],
                    warehouseTypes:[],
                },
                selectList:[],
                addDialogRules:{
                    warehouse_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    warehouse_type: [{ required: true, message: '不能为空', trigger: 'change' }],
                    monthly_rent: [{ required: true, message: '不能为空', trigger: 'change' }],
                    payee: [{ required: true, message: '不能为空', trigger: 'change' }],
                    init_cube:[{ required: true, message: '不能为空', trigger: 'change' }],
                },
            }
        },
        created(){
            this.getList()
            this.getSelectList('warehouse');
            this.getSelectList('warehouseTypes');
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            checkSelectable(row){
                if(row.isCanSelection){
                    return false;
                }else{
                    return true;
                }
            },
            rowClick(){

            },
            //期初仓储费
            toBeGenerated(id){
                this.$confirm('此操作将根据整租日均库存或监管日均单价设置，结算至前一天的仓储费金额，是否确定生成期初仓储费金额?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/warehouse.fee.init",{id:id},()=>{
                        this.getList()
                        this.tip("生成成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            empty(id){
                this.$confirm('是否确定清空仓储费金额?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/warehouse.fee.clear",{id:id},()=>{
                        this.getList()
                        this.tip("清空成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            changeStatus(id,status){
                if(status==1){
                    status=0
                }else{
                    status=1
                }
                this.postFunc("/erp/warehouse.fee.status.update",{id:id,status:status},()=>{
                    this.tip("修改成功","success")
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            edit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.addObj = JSON.parse(JSON.stringify(item));
                    }
                })
                this.type=3;
                this.addDialogVisible=true;
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/lock.level.delete",{id:id},()=>{
                        this.getList()
                        this.tip("删除成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(showMessage){
                this.postFunc("/erp/warehouse.fee.list",{},res=>{
                    res.data.data.forEach(item=>{
                        if(item.monthly_rent==0){
                            item.monthly_rent='-'
                        }
                        if(item.daily_rent==0){
                            item.daily_rent='-'
                        }
                        // if(item.fee_day==0){
                        //     item.fee_day='-'
                        // }
                    })
                    this.list = res.data.data;
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            selectionChange(row){
                this.selectList = row;
            },
            add(){
                // let time = this.warehouseForm.fee_day;
                // this.warehouseForm.fee_day = this.formatTimeZero(this.warehouseForm.fee_day)
                this.postFunc('/erp/warehouse.fee.add',this.warehouseForm,()=>{
                    this.addDialogVisible=false;
                    this.tip("添加成功","success")
                    this.getList()
                },error=>{
                    // this.warehouseForm.fee_day = time;
                    this.tip(error.data.message,"warning")
                })
                // let url="";
                // if(this.type==2){
                //     url="/erp/lock.level.create";
                // }else if(this.type==3){
                //     url="/erp/lock.level.update";
                // }
                // this.postFunc(url,this.addObj,()=>{
                //     this.addDialogVisible=false;
                //     if(this.type==2){
                //         this.tip("添加成功","success")
                //     }else{
                //         this.tip("修改成功","success")
                //     }
                //     this.getList()
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
            },
            //删除
            batchDel(){
                if(this.selectList.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectList.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/warehouse.fee.delete",{ids:arr},()=>{
                            this.tip("删除成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            tableRowClassName({row}) {
                for(let i=0;i<this.selectList.length;i++){
                    if(this.selectList[i].id){
                        if(this.selectList[i].id==row.id){
                            return 'selectRow';
                        }
                    }
                }
                return '';
            },
            toggleSelection(row) {
                this.$refs.listDetailTable.toggleRowSelection(row);
            },
        },
        watch:{
            addDialogVisible:function(val){
                if(!val){
                    this.warehouseForm ={
                        warehouse_id:"",
                        warehouse_type:"",
                        monthly_rent:'',
                        daily_rent:'',
                        payee:'',
                        // fee_day:'',
                        remark:''
                    }
                }
            },
        }
    }
</script>
